import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  ModalController,
} from '@ionic/angular/standalone';
import {
  getHorlogeTotalTime,
  SaltHorlogeModel,
  transformWPBufferToModel,
  transformWPModelToBuffer,
  VSHorlogeModel,
  WPHorlogeModel,
} from '../../../../../helper/horloge';
import { convertMinutesToTime } from '../../../../../helper/convertSecondsToTime';
import Moment from 'moment';
import moment from 'moment';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  getTemperature,
  getTemperatureUnit,
} from '../../../../../helper/temperature';
import {
  P00061TemperatureType,
  P00061TemperatureTypeF,
} from '../../Enum/P00061TemperatureType';

@Component({
  selector: 'app-function-parameters-setting-clock-week-wp',
  templateUrl: './function-parameters-setting-clock-week-wp.component.html',
  styleUrls: ['./function-parameters-setting-clock-week-wp.component.scss'],
  imports: [
    IonContent,
    GlobalPageHeaderComponent,
    TranslatePipe,
    IonButton,
    IonLabel,
    IonList,
    IonItem,
    IonModal,
    IonFooter,
  ],
})
export class FunctionParametersSettingClockWeekWpComponent implements OnInit {
  private modalController = inject(ModalController);

  @Input() value: string = '';
  public valueResult: string = '';

  public horlogesModel: any = [];
  public selectModel: WPHorlogeModel | null = null;
  public selectModelStep: number = 0;

  isModalOpen = false;

  constructor() {}

  public list: any = [];
  public minuteInterval: number = 60;

  ngOnInit() {
    for (let i = 0; i < 60 * 24; i = i + this.minuteInterval) {
      this.list.push({ label: convertMinutesToTime(i), ref: i * 60 });
    }

    this.valueResult = this.value;
    this.horlogesModel = transformWPBufferToModel(this.valueResult);
  }

  onCloseSelectTimeIntervalChoice(
    ref: number,
    startDate: number,
    endDate: number,
    temperature: number,
  ) {
    this.isModalOpen = false;

    if (ref == -1) {
      this.horlogesModel.push({
        ref: this.horlogesModel.length + 1,
        start: startDate,
        end: endDate,
        temperature: temperature,
      });
    } else {
      for (let i = 0; i < this.horlogesModel.length; i++) {
        if (this.horlogesModel[i].ref == ref) {
          this.horlogesModel[i].start = startDate;
          this.horlogesModel[i].end = endDate;
          this.horlogesModel[i].temperature = temperature;
        }
      }
    }

    const buf = transformWPModelToBuffer(this.horlogesModel);
    this.valueResult = buf;
    this.horlogesModel = transformWPBufferToModel(buf);
  }

  secondeToHourMinute(time: number) {
    let h = Math.floor(time / (60 * 60));
    let m = Math.floor((time - h * 3600) / 60);

    return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0');
  }

  tempsTotal() {
    const time = getHorlogeTotalTime(this.horlogesModel);
    return this.secondeToHourMinute(time);
  }

  onCloseSelectTimeIntervalRemove(ref: number) {
    for (let i = 0; i < this.horlogesModel.length; i++) {
      if (this.horlogesModel[i].ref == ref) {
        this.horlogesModel.splice(i, 1);

        const buf = transformWPModelToBuffer(this.horlogesModel);
        this.valueResult = buf;
        this.horlogesModel = transformWPBufferToModel(buf);
        break;
      }
    }

    this.isModalOpen = false;
  }

  transformNumberToDegree(num: number) {
    return (num * 360) / (60 * 60 * 24);
  }

  getLeftPos(num: number) {
    return (num * 100) / (3600 * 24);
  }

  getSize(num: number) {
    return (num / (3600 * 24)) * 100;
  }

  selectTemperature(value: number) {
    this.selectModel!.temperature = value;
  }

  nextStep() {
    this.selectModelStep = this.selectModelStep + 1;
  }

  goToStep(step: number) {
    this.selectModelStep = step;
  }

  selectStart(value: number) {
    this.selectModel!.start = value;
  }

  selectEnd(value: number) {
    this.selectModel!.end = value;
  }

  openModal(selectModel: VSHorlogeModel | null = null) {
    if (selectModel == null) {
      let hourStr = Moment().format('HH');
      this.selectModelStep = 0;
      this.selectModel = {
        ref: -1,
        start: parseInt(hourStr) * 3600,
        end: ((parseInt(hourStr) + 1) % 24) * 3600,
        temperature: 20.1,
      };
    } else {
      this.selectModel = JSON.parse(JSON.stringify(selectModel));
      this.selectModelStep = 3;
    }

    console.log(this.selectModel);
    this.isModalOpen = true;
  }

  deleteModel() {
    this.onCloseSelectTimeIntervalRemove(this.selectModel!.ref);
  }

  saveModel() {
    this.onCloseSelectTimeIntervalChoice(
      this.selectModel!.ref,
      this.selectModel!.start,
      this.selectModel!.end,
      this.selectModel!.temperature,
    );
  }

  closeModal() {
    this.isModalOpen = false;
    this.selectModel = null;
  }

  async dismissModal(): Promise<void> {
    await this.modalController.dismiss({ value: this.valueResult });
  }

  getStartDate() {
    return moment.utc(this.selectModel!.start! * 1000).format('HH:mm');
  }
  getEndDate() {
    return moment.utc(this.selectModel!.end! * 1000).format('HH:mm');
  }

  protected readonly getTemperature = getTemperature;
  protected readonly getTemperatureUnit = getTemperatureUnit;
  protected readonly P00061TemperatureTypeF = P00061TemperatureTypeF;
  protected readonly P00061TemperatureType = P00061TemperatureType;
}
